import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css'; 

const CATEGORIES = ["VALORANT", "BGMI", "MINECRAFT", "FF", "Streamers", "Content Creators", "Shorts Creators", "Editors"];
const BG_CATEGORIES = ["HOME"]; 
const API_URL = "https://vrx-website.onrender.com"; 

const CLOUD_NAME = "dupl3owvx"; 
const UPLOAD_PRESET = "VRX-WEBSITE"; 

function Admin() {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [uploading, setUploading] = useState(false);
  
  const [data, setData] = useState({ roster: [], owners: [], collaborators: [], events: [], partners: [], youtubeApiKeys: [] });
  
  const [general, setGeneral] = useState({
    heroTitle: "VORTEX", heroHighlight: "ORIGINALS", subHero: "DEFINING THE META",
    discordLink: "", 
    visionTitle: "OUR VISION", visionText1: "", visionTagline: "#VORTEXORIGINALS",
    newsTicker: "", statMembers: "", statWins: "", statTourneys: ""
  });

  const [backgrounds, setBackgrounds] = useState({ 
    HOME: {type: 'image', url: ''}
  });

  const [activeTab, setActiveTab] = useState('ROSTER');
  const [statusMsg, setStatusMsg] = useState('');

  useEffect(() => {
    const session = localStorage.getItem('vrx_admin_session');
    if (session) {
        if (Date.now() < parseInt(session, 10)) {
            setIsAuthenticated(true);
        } else {
            localStorage.removeItem('vrx_admin_session'); 
        }
    }

    const fetchData = async () => {
        try {
          const res = await axios.get(`${API_URL}/api/data`);
          setData(res.data);
          if(res.data.general) setGeneral(prev => ({...prev, ...res.data.general}));
          if(res.data.backgrounds) {
             const newBgs = {};
             if(res.data.backgrounds['HOME']) {
                 const bg = res.data.backgrounds['HOME'];
                 newBgs['HOME'] = (typeof bg === 'string') ? { type: 'image', url: bg } : bg;
             }
             setBackgrounds(prev => ({...prev, ...newBgs}));
          }
        } catch (err) { console.error("Server Error"); }
    };
    fetchData();
  }, []);

  const handleLogin = (e) => { 
      e.preventDefault(); 
      if (password === "Ninja@1911") {
          setIsAuthenticated(true);
          localStorage.setItem('vrx_admin_session', Date.now() + 30 * 60 * 1000); 
      } else {
          alert("ACCESS DENIED"); 
      }
  };
  
  const handleImageUpload = async (file) => { 
    const formData = new FormData(); 
    formData.append("file", file); 
    formData.append("upload_preset", UPLOAD_PRESET); 
    try { 
      setUploading(true); 
      const res = await axios.post(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, formData); 
      setUploading(false); 
      return res.data.secure_url; 
    } catch (error) { 
      setUploading(false); 
      alert("UPLOAD FAILED"); 
      return null; 
    } 
  };

  const updateItem = (col, id, f, v) => setData({...data, [col]: data[col].map(i => i.id === id ? {...i, [f]: v} : i)});
  const deleteItem = (col, id) => { if(window.confirm("DELETE?")) setData({...data, [col]: data[col].filter(i => i.id !== id)}); };
  const handleFileChange = async (col, id, file) => { const url = await handleImageUpload(file); if(url) updateItem(col, id, 'img', url); };
  const addItem = (col, item) => setData({...data, [col]: [...(data[col]||[]), {id: Date.now(), ...item}]});
  const updateBackground = (game, field, value) => setBackgrounds({ ...backgrounds, [game]: { ...backgrounds[game], [field]: value } });
  const handleBgFileChange = async (game, file) => { const url = await handleImageUpload(file); if(url) updateBackground(game, 'url', url); };

  const saveChanges = async () => {
    setStatusMsg("SAVING...");
    try {
      await axios.post(`${API_URL}/api/update-roster`, data.roster);
      await axios.post(`${API_URL}/api/update-owners`, data.owners);
      await axios.post(`${API_URL}/api/update-collaborators`, data.collaborators);
      await axios.post(`${API_URL}/api/update-events`, data.events);
      await axios.post(`${API_URL}/api/update-partners`, data.partners);
      await axios.post(`${API_URL}/api/update-general`, general);
      await axios.post(`${API_URL}/api/update-backgrounds`, backgrounds);
      // 🚀 FIX: Wraps the array in an object { keys: [...] } to prevent strict JSON parsing bugs
      await axios.post(`${API_URL}/api/update-apikeys`, { keys: data.youtubeApiKeys || [] }); 
      
      setStatusMsg("SAVED ✓");
      setTimeout(() => setStatusMsg(""), 3000);
    } catch (err) { 
      console.error("Save Error:", err);
      setStatusMsg("ERROR"); 
    }
  };

  if (!isAuthenticated) return (
      <div className="hero" style={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#050505', backgroundImage: 'radial-gradient(circle, rgba(255,0,0,0.1) 0%, #000 70%)'}}>
        <form onSubmit={handleLogin} style={{display: 'flex', flexDirection: 'column', gap: '20px', width: '300px', background: '#0a0a0a', padding: '40px', border: '1px solid #333', borderRadius: '8px', boxShadow: '0 0 30px rgba(0,0,0,0.5)'}}>
          <h2 style={{color: 'red', textAlign: 'center', margin: '0 0 20px 0', fontFamily: 'Orbitron'}}>ADMIN ACCESS</h2>
          <input type="password" placeholder="PASSCODE" value={password} onChange={e=>setPassword(e.target.value)} style={{textAlign:'center', borderColor:'red', padding:'15px', background:'#000', color:'#fff'}}/>
          <button className="glitch-btn">UNLOCK</button>
        </form>
      </div>
  );

  const deleteBtnStyle = { background: '#ff0000', color: '#ffffff', border: 'none', padding: '12px', width: '100%', cursor: 'pointer', marginTop: '15px', fontWeight: '900', fontFamily: 'Orbitron', letterSpacing: '1px' };
  const labelStyle = { fontSize: '10px', color: '#888', marginBottom: '5px', display: 'block', fontWeight: 'bold' };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div><h1 style={{color: 'red', margin: 0}}>ADMIN (LIVE)</h1></div>
        <div style={{textAlign: 'right'}}>
            {uploading && <div style={{color: 'orange'}}>UPLOADING...</div>}
            <div style={{color: '#0f0'}}>{statusMsg}</div>
            <button onClick={saveChanges} className="glitch-btn" style={{width: '200px'}}>SAVE ALL</button>
        </div>
      </div>

      <div className="game-tabs" style={{justifyContent: 'flex-start', flexWrap: 'wrap'}}>
        <button className={`tab-btn ${activeTab === 'ROSTER' ? 'active' : ''}`} onClick={() => setActiveTab('ROSTER')}>AGENTS</button>
        <button className={`tab-btn ${activeTab === 'OWNERS' ? 'active' : ''}`} onClick={() => setActiveTab('OWNERS')}>COMMAND</button>
        <button className={`tab-btn ${activeTab === 'COLLABS' ? 'active' : ''}`} onClick={() => setActiveTab('COLLABS')}>COLLABS</button>
        <button className={`tab-btn ${activeTab === 'EVENTS' ? 'active' : ''}`} onClick={() => setActiveTab('EVENTS')}>EVENTS</button>
        <button className={`tab-btn ${activeTab === 'PARTNERS' ? 'active' : ''}`} onClick={() => setActiveTab('PARTNERS')}>PARTNERS</button>
        <button className={`tab-btn ${activeTab === 'GENERAL' ? 'active' : ''}`} onClick={() => setActiveTab('GENERAL')}>SETTINGS</button>
        <button className={`tab-btn ${activeTab === 'BACKGROUNDS' ? 'active' : ''}`} onClick={() => setActiveTab('BACKGROUNDS')}>BG</button>
      </div>

      {activeTab === 'ROSTER' && (
        <div>
          <button onClick={() => addItem('roster', {name: "NEW AGENT", role: "ROLE", category: "Streamers", img: "", link: "", description: "", youtube: "", instagram: "", hoverVideo: "", featuredVideo: "", isLive: "false", livePriority: 10})} className="hero-btn" style={{marginBottom: '20px', fontSize:'12px'}}>+ AGENT</button>
          <div className="card-grid">
            {(data.roster||[]).map(p => (
              <div key={p.id} className="admin-card">
                 <img src={p.img || "https://via.placeholder.com/150"} alt="" style={{width:'100%', height:'150px', objectFit:'cover', marginBottom: '10px', background:'#222'}}/>
                 
                 <label style={labelStyle}>NAME</label>
                 <input value={p.name} onChange={e => updateItem('roster', p.id, 'name', e.target.value)} />
                 <label style={labelStyle}>ROLE</label>
                 <input value={p.role} onChange={e => updateItem('roster', p.id, 'role', e.target.value)} />
                 <label style={labelStyle}>CATEGORY</label>
                 <select value={p.category} onChange={e => updateItem('roster', p.id, 'category', e.target.value)} style={{background:'#000', color:'#fff', padding:'10px'}}>
                    {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                 </select>

                 <label style={{...labelStyle, color:'#0f0', marginTop:'15px'}}>--- LIVE STATUS ---</label>
                 <label style={labelStyle}>IS LIVE NOW?</label>
                 <select value={p.isLive || "false"} onChange={e => updateItem('roster', p.id, 'isLive', e.target.value)} style={{background:'#000', color:'#fff', padding:'10px'}}>
                    <option value="false">OFFLINE</option>
                    <option value="true">🔴 LIVE NOW</option>
                 </select>
                 <label style={labelStyle}>LIVE PRIORITY (1 = Top of the list)</label>
                 <input type="number" value={p.livePriority || 10} onChange={e => updateItem('roster', p.id, 'livePriority', Number(e.target.value))} />

                 <label style={{...labelStyle, color:'cyan', marginTop:'15px'}}>--- PROFILE DETAILS ---</label>
                 <label style={labelStyle}>DESCRIPTION</label>
                 <textarea value={p.description || ""} onChange={e => updateItem('roster', p.id, 'description', e.target.value)} style={{height: '60px'}}/>
                 
                 <label style={labelStyle}>YOUTUBE URL</label>
                 <input value={p.youtube || ""} onChange={e => updateItem('roster', p.id, 'youtube', e.target.value)} />
                 
                 <label style={labelStyle}>INSTAGRAM URL</label>
                 <input value={p.instagram || ""} onChange={e => updateItem('roster', p.id, 'instagram', e.target.value)} />

                 <label style={{...labelStyle, color:'orange', marginTop:'15px'}}>--- MEDIA ---</label>
                 <label style={labelStyle}>UPLOAD PROFILE IMAGE</label>
                 <input type="file" onChange={e => handleFileChange('roster', p.id, e.target.files[0])}/>
                 <label style={labelStyle}>OR PASTE IMAGE URL</label>
                 <input value={p.img} onChange={e => updateItem('roster', p.id, 'img', e.target.value)} />

                 <label style={labelStyle}>HOVER VIDEO (YouTube URL or MP4)</label>
                 <input value={p.hoverVideo || ""} onChange={e => updateItem('roster', p.id, 'hoverVideo', e.target.value)} placeholder="https://youtube.com/watch?v=..."/>
                 
                 <label style={labelStyle}>FEATURED VIDEO (YouTube URL)</label>
                 <input value={p.featuredVideo || ""} onChange={e => updateItem('roster', p.id, 'featuredVideo', e.target.value)} placeholder="https://youtube.com/watch?v=..."/>

                 <button onClick={() => deleteItem('roster', p.id)} style={deleteBtnStyle}>DELETE</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'OWNERS' && (
        <div>
          <button onClick={() => addItem('owners', {name: "NEW COMMANDER", role: "ROLE", img: "", link: ""})} className="hero-btn" style={{marginBottom: '30px', fontSize:'12px'}}>+ COMMANDER</button>
          <div className="card-grid">
            {(data.owners||[]).map(o => (
              <div key={o.id} className="admin-card" style={{borderColor:'red'}}>
                 <img src={o.img || "https://via.placeholder.com/150"} alt="" style={{width:'100%', height:'150px', objectFit:'cover', marginBottom: '10px'}}/>
                 <label style={labelStyle}>NAME</label>
                 <input value={o.name} onChange={e => updateItem('owners', o.id, 'name', e.target.value)} />
                 <label style={labelStyle}>ROLE</label>
                 <input value={o.role} onChange={e => updateItem('owners', o.id, 'role', e.target.value)} />
                 <label style={labelStyle}>UPLOAD IMAGE</label>
                 <input type="file" onChange={e => handleFileChange('owners', o.id, e.target.files[0])}/>
                 <label style={labelStyle}>OR PASTE IMAGE URL</label>
                 <input value={o.img} onChange={e => updateItem('owners', o.id, 'img', e.target.value)} />
                 <label style={labelStyle}>LINK</label>
                 <input value={o.link} onChange={e => updateItem('owners', o.id, 'link', e.target.value)} />
                 <button onClick={() => deleteItem('owners', o.id)} style={deleteBtnStyle}>DELETE</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'EVENTS' && (
        <div>
          <button onClick={() => addItem('events', {name: "EVENT", date: "DATE", img: "", link: ""})} className="hero-btn" style={{marginBottom: '30px', fontSize:'12px'}}>+ EVENT</button>
          <div className="card-grid">
            {(data.events||[]).map(ev => (
              <div key={ev.id} className="admin-card" style={{borderColor:'yellow'}}>
                 <img src={ev.img || "https://via.placeholder.com/150"} alt="" style={{width:'100%', height:'150px', objectFit:'cover', marginBottom: '10px'}}/>
                 <label style={labelStyle}>TITLE</label>
                 <input value={ev.name} onChange={e => updateItem('events', ev.id, 'name', e.target.value)} />
                 <label style={labelStyle}>DATE</label>
                 <input value={ev.date} onChange={e => updateItem('events', ev.id, 'date', e.target.value)} />
                 <label style={labelStyle}>IMAGE</label>
                 <input type="file" onChange={e => handleFileChange('events', ev.id, e.target.files[0])}/>
                 <input value={ev.img} onChange={e => updateItem('events', ev.id, 'img', e.target.value)} placeholder="Image URL"/>
                 <label style={labelStyle}>STREAM LINK</label>
                 <input value={ev.link} onChange={e => updateItem('events', ev.id, 'link', e.target.value)} />
                 <button onClick={() => deleteItem('events', ev.id)} style={deleteBtnStyle}>DELETE</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'PARTNERS' && (
        <div>
          <button onClick={() => addItem('partners', {name: "PARTNER", role: "Description here...", img: "", link: ""})} className="hero-btn" style={{marginBottom: '30px', fontSize:'12px'}}>+ PARTNER</button>
          <div className="card-grid">
            {(data.partners||[]).map(p => (
              <div key={p.id} className="admin-card" style={{borderColor:'#fff'}}>
                 <img src={p.img || "https://via.placeholder.com/150"} alt="" style={{width:'100%', height:'100px', objectFit:'contain', background:'#333', marginBottom: '10px'}}/>
                 <label style={labelStyle}>PARTNER NAME</label>
                 <input value={p.name} onChange={e => updateItem('partners', p.id, 'name', e.target.value)} />
                 <label style={labelStyle}>DESCRIPTION (Role/About)</label>
                 <textarea value={p.role} onChange={e => updateItem('partners', p.id, 'role', e.target.value)} style={{height: '60px'}}/>
                 <label style={labelStyle}>UPLOAD LOGO</label>
                 <input type="file" onChange={e => handleFileChange('partners', p.id, e.target.files[0])}/>
                 <label style={labelStyle}>OR PASTE LOGO URL</label>
                 <input value={p.img} onChange={e => updateItem('partners', p.id, 'img', e.target.value)} />
                 <label style={labelStyle}>WEBSITE LINK</label>
                 <input value={p.link} onChange={e => updateItem('partners', p.id, 'link', e.target.value)} />
                 <button onClick={() => deleteItem('partners', p.id)} style={deleteBtnStyle}>DELETE</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'COLLABS' && (
        <div>
          <button onClick={() => addItem('collaborators', {name: "NAME", role: "PARTNER", img: "", link: ""})} className="hero-btn" style={{marginBottom: '30px', fontSize:'12px'}}>+ FRIEND</button>
          <div className="card-grid">
            {(data.collaborators||[]).map(c => (
              <div key={c.id} className="admin-card" style={{borderColor:'cyan'}}>
                 <img src={c.img || "https://via.placeholder.com/150"} alt="" style={{width:'100%', height:'150px', objectFit:'cover', marginBottom: '10px'}}/>
                 <label style={labelStyle}>NAME</label>
                 <input value={c.name} onChange={e => updateItem('collaborators', c.id, 'name', e.target.value)} />
                 <label style={labelStyle}>DESC</label>
                 <input value={c.role} onChange={e => updateItem('collaborators', c.id, 'role', e.target.value)} />
                 <label style={labelStyle}>IMAGE</label>
                 <input type="file" onChange={e => handleFileChange('collaborators', c.id, e.target.files[0])}/>
                 <input value={c.img} onChange={e => updateItem('collaborators', c.id, 'img', e.target.value)} placeholder="Image URL"/>
                 <label style={labelStyle}>LINK</label>
                 <input value={c.link} onChange={e => updateItem('collaborators', c.id, 'link', e.target.value)} />
                 <button onClick={() => deleteItem('collaborators', c.id)} style={deleteBtnStyle}>DELETE</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'GENERAL' && (
        <div style={{maxWidth:'600px', margin:'0 auto', background:'#111', padding:'20px'}}>
            <div style={{display:'grid', gap:'10px'}}>
              <h3 style={{color:'red'}}>HERO SECTION</h3>
              <label style={labelStyle}>MAIN TITLE</label><input value={general.heroTitle||""} onChange={e => setGeneral({...general, heroTitle: e.target.value})}/>
              <label style={labelStyle}>HIGHLIGHT</label><input value={general.heroHighlight||""} onChange={e => setGeneral({...general, heroHighlight: e.target.value})}/>
              <label style={labelStyle}>DISCORD LINK</label><input value={general.discordLink||""} onChange={e => setGeneral({...general, discordLink: e.target.value})} placeholder="https://discord.gg/..."/>

              <h3 style={{color:'red', marginTop: '20px'}}>VISION SECTION</h3>
              <label style={labelStyle}>TITLE</label><input value={general.visionTitle||""} onChange={e => setGeneral({...general, visionTitle: e.target.value})}/>
              <label style={labelStyle}>TEXT</label><textarea value={general.visionText1||""} onChange={e => setGeneral({...general, visionText1: e.target.value})} style={{height:'100px'}}/>
              <label style={labelStyle}>TAGLINE</label><input value={general.visionTagline||""} onChange={e => setGeneral({...general, visionTagline: e.target.value})}/>

              <h3 style={{color:'#0f0', marginTop: '20px'}}>LIVE SETTINGS</h3>
              <label style={labelStyle}>NEWS TICKER</label><input value={general.newsTicker||""} onChange={e => setGeneral({...general, newsTicker: e.target.value})} style={{color:'#0f0', borderColor:'#0f0'}}/>
              
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:'10px'}}>
                 <div><label style={labelStyle}>STATUS 1</label><input value={general.statMembers||""} onChange={e=>setGeneral({...general, statMembers:e.target.value})}/></div>
                 <div><label style={labelStyle}>STATUS 2</label><input value={general.statWins||""} onChange={e=>setGeneral({...general, statWins:e.target.value})}/></div>
                 <div><label style={labelStyle}>STATUS 3</label><input value={general.statTourneys||""} onChange={e=>setGeneral({...general, statTourneys:e.target.value})}/></div>
              </div>

              <h3 style={{color:'cyan', marginTop: '30px'}}>YOUTUBE API KEYS</h3>
              <p style={{fontSize: '12px', color: '#888', margin: '0 0 15px 0'}}>Add multiple keys. The system will auto-rotate if one hits the quota limit.</p>
              
              {(data.youtubeApiKeys || []).map((key, index) => (
                  <div key={index} style={{display: 'flex', gap: '10px', marginBottom: '10px'}}>
                      <input 
                          value={key} 
                          onChange={e => {
                              const newKeys = [...(data.youtubeApiKeys || [])];
                              newKeys[index] = e.target.value;
                              setData({...data, youtubeApiKeys: newKeys});
                          }} 
                          placeholder="Paste YouTube API Key here"
                      />
                      <button 
                          onClick={() => {
                              const newKeys = (data.youtubeApiKeys || []).filter((_, i) => i !== index);
                              setData({...data, youtubeApiKeys: newKeys});
                          }} 
                          style={{...deleteBtnStyle, width: '80px', margin: 0, padding: '10px'}}
                      >
                          DEL
                      </button>
                  </div>
              ))}
              <button 
                  onClick={() => setData({...data, youtubeApiKeys: [...(data.youtubeApiKeys || []), ""]})} 
                  className="hero-btn" 
                  style={{fontSize: '12px', padding: '10px', width: '100%'}}
              >
                  + ADD API KEY
              </button>
            </div>
        </div>
      )}

      {activeTab === 'BACKGROUNDS' && (
         <div style={{display:'grid', gap:'20px', gridTemplateColumns:'repeat(auto-fill, minmax(300px, 1fr))'}}>
            {BG_CATEGORIES.map(game => (
               <div key={game} className="admin-card" style={{borderColor: game === 'HOME' ? '#0f0' : '#333'}}>
                  <h4 style={{color: game === 'HOME' ? '#0f0' : 'red', margin:0}}>{game} BG</h4>
                  <div style={{width:'100%', height:'150px', background:'#000', marginBottom:'10px'}}>
                      {backgrounds[game]?.type === 'video' ? (
                          <video src={backgrounds[game].url} style={{width:'100%', height:'100%', objectFit:'cover'}} muted />
                      ) : (
                          <img src={backgrounds[game]?.url || ""} alt="" style={{width:'100%', height:'100%', objectFit:'cover'}}/>
                      )}
                  </div>
                  <label style={labelStyle}>TYPE</label>
                  <select value={backgrounds[game]?.type || 'image'} onChange={e => updateBackground(game, 'type', e.target.value)} style={{background:'#000', color:'#fff', padding:'5px', marginBottom:'10px'}}>
                      <option value="image">IMAGE</option>
                      <option value="video">VIDEO</option>
                  </select>
                  <label style={labelStyle}>UPLOAD</label>
                  <input type="file" onChange={e => handleBgFileChange(game, e.target.files[0])}/>
                  <label style={labelStyle}>URL</label>
                  <input value={backgrounds[game]?.url || ""} onChange={e => updateBackground(game, 'url', e.target.value)}/>
               </div>
            ))}
         </div>
      )}
    </div>
  );
}

export default Admin;